import qs from 'qs'
import Env from './env'

const USER_INFO = 'mini_active_userInfo'
const sso_public_path = process.env.VUE_APP_SSO_PUBLIC_PATH
// 获取url参数
const getUrlUserInfo = () => {
  let result = null
  const searchString = window.location.search
  try {
    result = qs.parse(searchString.split('?')[1])
  } catch (error) {
    console.error(error)
  }
  return result
}
const getUserInfoByJSbridge = () => {
  return new Promise((resolve, reject) => {
    try {
      window.mnw.getUserAuth(function (result) {
        resolve(result)
      })
    } catch (error) {
      console.error('获取getUserInfoByJSbridge失败', error)
      reject()
    }
  })
}

const setUserInfo = (value) => {
  window.sessionStorage.setItem(USER_INFO, JSON.stringify(value || {}))
}
const getUserInfo = () => {
  const result = {}
  const userInfo = window.sessionStorage.getItem(USER_INFO)
  if (!userInfo) return result
  try {
    const user = JSON.parse(userInfo)
    Object.keys(user).forEach(key => {
      result[key] = decodeURIComponent(user[key] || '')
    })
  } catch (error) {
    console.error(error)
  }
  return result
}

/**
 * 1.仅游戏内  2.游戏内外（非必须登陆）
 */
const init = async (type) => {
  let userInfo = null

  const hasUser = () => userInfo && userInfo.uin
  const isInGame = window.mnw && window.mnw.getUserAuth
  userInfo = getUrlUserInfo() // 任何情况下url参数优先级最高
  if (!hasUser()) {
    if (isInGame) { // 游戏内
      userInfo = await getUserInfoByJSbridge()
    } else {
      if (type && type === 2) { // 游戏外打开
        ['uin', 'ver', 'apiid', 'lang', 'country', 'auth', 'time', 's2t', 'headIndex', 'nickName', 'sign'].forEach(key => {
          if (key === 'nickName') {
            userInfo.nickname = decodeURIComponent(Utils.getCookie(key) || '')
          } else {
            userInfo[key] = decodeURIComponent(Utils.getCookie(key) || '')
          }
        })
      } else if (Env.IS_DEV) { // 游戏内打开的项目必须登陆开发环境情况下 测试用
        userInfo = {
          openBrowser: '1',
          uin: '734676044',
          ver: '0.43.0',
          apiid: '999',
          lang: '0',
          country: 'CN',
          auth: 'ee5e418ba5cef9ff146e630843eef74b',
          time: '1587204294',
          s2t: '1587204277',
          headIndex: '2',
          nickname: '灰骑老头'
        }
      }
    }
  }
  setUserInfo(userInfo)
}

export default {
  init,
  getUserInfo,
  toSsoLogin: () => {
    window.location.href = `${sso_public_path}?url=${location.href}`
  }
}
